import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workSuggestionsTitleNonFinal: {
		id: 'software-code-code-page.pages.main-page.work-suggestions.work-suggestions-title-non-final',
		defaultMessage: 'Work suggestions',
		description: 'The title for the work suggestions section within the code tab page.',
	},
});
